import { Guid } from '@ebeihilfe/core';

import { AntragMetaData } from '../model';

export class PartiallyTypedNewAntrag {
  public antragId: Guid;
  public concurrency: Date;
  public metadata?: AntragMetaData;
  public surveyData?: Record<string, unknown>;

  constructor(antragId: Guid, concurrency: Date, metadata?: AntragMetaData, surveyData?: Record<string, unknown>) {
    this.antragId = antragId;
    this.concurrency = concurrency;
    this.metadata = metadata;
    this.surveyData = surveyData;
  }
}
